// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K2fO","tabsBox":"styles_tabsBox__2PcMq","createButton":"styles_createButton__2A1Tx"};